// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer_footerContainer__30uj-"};